"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateDisplayEventDto = void 0;
const display_event_type_1 = require("../../../types/display-event.type");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const display_event_screenshot_dto_1 = require("./display-event-screenshot.dto");
class CreateDisplayEventDto {
    timestamp;
    category;
    type;
    severity;
    payload;
    source;
    screenshot;
}
exports.CreateDisplayEventDto = CreateDisplayEventDto;
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsDateString)(),
    __metadata("design:type", Object)
], CreateDisplayEventDto.prototype, "timestamp", void 0);
__decorate([
    (0, class_validator_1.IsIn)(display_event_type_1.DISPLAY_EVENT_CATEGORIES),
    __metadata("design:type", String)
], CreateDisplayEventDto.prototype, "category", void 0);
__decorate([
    (0, class_validator_1.IsIn)(display_event_type_1.DISPLAY_EVENT_TYPES),
    __metadata("design:type", String)
], CreateDisplayEventDto.prototype, "type", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsIn)(display_event_type_1.DISPLAY_EVENT_SEVERITIES),
    __metadata("design:type", String)
], CreateDisplayEventDto.prototype, "severity", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsObject)(),
    __metadata("design:type", Object)
], CreateDisplayEventDto.prototype, "payload", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], CreateDisplayEventDto.prototype, "source", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => display_event_screenshot_dto_1.DisplayEventScreenshotDto),
    __metadata("design:type", display_event_screenshot_dto_1.DisplayEventScreenshotDto)
], CreateDisplayEventDto.prototype, "screenshot", void 0);
